import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import "../../styles/broadcast-system/broadcast-system.css";
import EmailTemplateStructure from "../../components/broadcast-system/templates/email-template/EmailTemplateStructure";
import WPTemplateStructure from "../../components/broadcast-system/templates/whatsapp-template/WPTemplateStructure";

const Templates = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Broadcast Templates">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <div className="odm-tabs-new">
              <Tabs>
                <TabList>
                  <Tab>Whatsapp Template</Tab>
                  <Tab>Email Template</Tab>
                </TabList>

                <TabPanel>
                  <WPTemplateStructure userInfoData={userInfoData} />
                </TabPanel>
                <TabPanel>
                  <EmailTemplateStructure userInfoData={userInfoData} />
                </TabPanel>
              </Tabs>
            </div>
          </Col>
        </Row>

        {/* <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div className="createNewCTOModalContainer mod-width-50p">
            <ModalHeadAndClose
              title={
                modValues.modName === "add" || modValues.modName === "edit"
                  ? `${modValues.modName?.replace(/_/g, " ")} Template`
                  : "Template Details"
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p
                  className="message"
                  dangerouslySetInnerHTML={{
                    __html: modValues.rowData?.body || "No Content Available",
                  }}></p>
              </div>
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <TemplateForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={() => getTemplates(filters)}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Broadcast Templates"}
              isReload={() => getTemplates(filters)}
              createBtnTxt={"+ Add New Template"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="broadcast-templates"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={broadcastTemplatesLoading}
              searchPlaceHolder="Search by template name..."
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <TemplateListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getTemplates(filters)}
            />
          </Col>
        </Row> */}
      </Container>
    </HelmetWrapper>
  );
};

export default Templates;
